import clsx from 'clsx';
import type * as React from 'react';

import { emojisByCode, getEmojiForCode } from '@gitbook/util-emojis';

// ❓
const notFoundEmojiCode = '2753';

/**
 * Render a single emoji from an UTF code.
 */
export function Emoji(props: {
    code: string;
    size?: number;
    className?: string;
    style?: React.CSSProperties;
}): React.ReactElement {
    const { size = 32, className, style } = props;

    const code = emojisByCode[props.code] ? props.code : notFoundEmojiCode;
    const emoji = emojisByCode[code];
    const character = getEmojiForCode(code);

    return (
        <span
            className={clsx('font-emoji', className)}
            role="img"
            aria-label={emoji.name}
            style={{
                fontSize: `${size / 16}rem`,
                lineHeight: `${size / 16}rem`,
                ...style,
            }}
        >
            {character}
        </span>
    );
}
